module.exports = __webpack_public_path__ + "static/media/meetings.1df90064.jpeg";